import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';
import type { ResultOf } from 'gql.tada';

// Posts the invoice rows an admin selected on the Invoices card to Stripe. Which
// rows may be selected is the backend's call (`postable` / `postDisabledReason`
// on each row); the report says what happened to each one.
const PostInvoicesMutation = graphql.persisted(
  "PostInvoices",
  graphql(`
    mutation PostInvoices($input: PostInvoicesInput!) {
      postInvoices(input: $input) {
        success
        report {
          pushedCount
          noticesQueued
          warnings
          rows {
            invoiceId
            action
            message
            feeCents
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export type PostInvoicesReport = NonNullable<
  NonNullable<ResultOf<typeof PostInvoicesMutation>['postInvoices']>['report']
>;

export { PostInvoicesMutation };

export function usePostInvoices() {
  return useMutation(PostInvoicesMutation);
}
